import _get from 'lodash/get'
import queryString from 'query-string'

//must match UserDeactivation::CODE / ::MESSAGE in app/Lib/UserDeactivation.php
export const USER_DEACTIVATED_CODE = 'USER_DEACTIVATED'
export const USER_DEACTIVATED_MESSAGE = 'Your account has been deactivated. Please contact your company administrator.'

export const LOGIN_TIMED_OUT_MESSAGE = 'Your login has timed out. Please log in again.'

export const isUserDeactivatedResponse = body => _get(body, 'message.code') === USER_DEACTIVATED_CODE

//where an api response that ended the session should send the browser, or null to let the caller handle it.
//a 401 with the code is the per-request kick; a bare 403 is Cake's Auth timing out.
//both login refusals (401 bad credentials, 403 + code) stay with the login form so it can show the reason
export const sessionEndedRedirect = (status, body) => {
	const deactivated = isUserDeactivatedResponse(body)

	if( status === 401 && deactivated ) return '/Login?reason=deactivated'
	if( status === 403 && !deactivated ) return '/Login?reason=timeout'

	return null
}

const LOGIN_REASON_MESSAGES = new Map([
	['deactivated', USER_DEACTIVATED_MESSAGE],
	['timeout', LOGIN_TIMED_OUT_MESSAGE]
])

//the per-request kick redirects page loads to /Login?reason=deactivated, a timed-out api call to /Login?reason=timeout
export const loginReasonMessage = search => LOGIN_REASON_MESSAGES.get(queryString.parse(search).reason) || false
